module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    attrs: {
      "transition": _vm.transition
    }
  }, [_c('div', {
    staticClass: "modal",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.clickMask($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    class: _vm.modalClass,
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._t("header", [_c('div', {
    staticClass: "modal-header"
  }, [_c('a', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._t("title", [_vm._v("\n                                " + _vm._s(_vm.title) + "\n                            ")])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", [(_vm.showOk) ? _c('button', {
    class: _vm.okClass,
    attrs: {
      "id": "okBtn",
      "type": "button"
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v(_vm._s(_vm.okText))]) : _vm._e(), _vm._v(" "), _c('button', {
    class: _vm.cancelClass,
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.cancelText))])])], 2)], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-backdrop in"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-105a12c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/utils/vue/bootstrap-modal.vue
// module id = 921
// module chunks = 0